import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { connect } from 'react-redux'
import { initialize } from 'redux-form'
import { bindActionCreators } from 'redux'

import { ContatoForm } from '../../components'
import * as contatoClienteActionCreators from '../../redux/modules/contatoCliente'
import * as funcaoActionCreators from '../../redux/modules/funcao'
import * as flashMessageActionCreators from '../../redux/modules/flashMessage'

import { mapToDropdown } from '../../utils/parse'

class ContatoClienteFormContainer extends Component {
  static propTypes = {
    id: PropTypes.string,
    initialize: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    cliente: PropTypes.object,

    fetchContatoCliente: PropTypes.func.isRequired,
    createContatoCliente: PropTypes.func.isRequired,
    updateContatoCliente: PropTypes.func.isRequired,

    funcaoDropdown: PropTypes.array.isRequired,
    fetchMultipleFuncao: PropTypes.func.isRequired,

    showSuccessfulFlashMessage: PropTypes.func.isRequired,
    showErrorFlashMessage: PropTypes.func.isRequired,
    shouldHideFlashMessage: PropTypes.bool.isRequired,
    hideFlashMessage: PropTypes.func.isRequired,

    error: PropTypes.object,
  }

  async componentDidMount () {
    await this.props.fetchMultipleFuncao()
    if (this.props.id) {
      const contato = await this.props.fetchContatoCliente(this.props.id)
      this.props.initialize('ContatoForm', { contato })
    }
  }

  handleUpdate = async (contatoCliente) => {
    const clienteId = this.props.cliente.id

    if (await this.props.updateContatoCliente(this.props.id, contatoCliente)) {
      this.props.showSuccessfulFlashMessage('', 'update')
      this.props.history.push(`/clientes/${clienteId}/contatos`)
    } else {
      this.props.showErrorFlashMessage('', 'update', this.props.error)
    }
  }

  handleCreate = async (contatoCliente) => {
    const clienteId = this.props.cliente.id

    if (await this.props.createContatoCliente(clienteId, contatoCliente)) {
      this.props.showSuccessfulFlashMessage('', 'create')
      this.props.history.push(`/clientes/${clienteId}/contatos`)
    } else {
      this.props.showErrorFlashMessage('', 'create', this.props.error)
    }
  }

  handleSubmitResource = async (contatoCliente) => {
    if (this.props.id) {
      this.handleUpdate(contatoCliente)
    } else {
      this.handleCreate(contatoCliente)
    }
  }

  componentWillUnmount () {
    if (this.props.shouldHideFlashMessage)
      this.props.hideFlashMessage()
  }

  render () {
    return (
      <ContatoForm titleAs='h3' noPadded
        funcaoDropdown={this.props.funcaoDropdown}
        onSubmit={(contatoCliente) => this.handleSubmitResource(contatoCliente)} />
    )
  }
}

function mapStateToProps ({contatoCliente, funcao, status, flashMessage}, {match}) {
  const { id } = match.params

  const funcaoDropdown = mapToDropdown(
    funcao,
    e => e.get('id'),
    e => e.get('nome')
  )

  if (id) {
    return {
      id,
      contatoCliente: contatoCliente.get('id'),
      funcaoDropdown,
      error: status.getIn(['contatoCliente', 'error']),
      shouldHideFlashMessage: flashMessage.get('isError'),
    }
  }
  return {
    funcaoDropdown,
    error: status.getIn(['contatoCliente', 'error']),
    shouldHideFlashMessage: flashMessage.get('isError'),
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...contatoClienteActionCreators,
    ...funcaoActionCreators,
    ...flashMessageActionCreators,
    ...{initialize},
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContatoClienteFormContainer))
